export default "__VITE_ASSET__ASXng6yA__"